const ja = {
  home: {
    biometric_label: "生体認証による本人確認",
    title: "顔の逆引き検索を簡単に",
    description:
      "高解像度の肖像写真をアップロードして、高度なニューラルマッチングを使用したグローバルデジタルアーカイブとの照合を行います。",
    drag_drop: "画像をドラッグ＆ドロップ",
    file_formats: "RAW、JPEG、PNG対応（最大15MB）",
    select_file: "システムからファイルを選択",
    initiate_scan: "フォレンジックスキャン開始",
    upload_hint: "続行するには画像をアップロードしてください",
    uploading: "アップロード中",
    searching: "スキャン中",
    result_title: "結果",
    drop_here: "ここに画像をドロップ...",
    billion_faces: "インターネット上の10億以上の顔と比較",
    login_to_search: "検索するにはログイン",
    login_required:
      "このアプリを使用するにはログインまたはアカウントを作成してください",
    not_enough_tokens: "トークンが不足しています",
    please_wait: "数分間お待ちください",
    leave_confirmation: "処理が実行中です。ページを離れてよろしいですか？",
  },
  sources: {
    section_title: "検索対象ソース",
    social_media: {
      name: "ソーシャルメディア",
      description: "主要なソーシャルネットワークや公開プロフィールとの照合。",
    },
    web: {
      name: "ウェブ",
      description: "公開されている顔データをオープンウェブ上でスキャン。",
    },
    scammers: {
      name: "詐欺師",
      description: "既知の詐欺師の身元・詐欺データベースとの照合。",
    },
    sexual_offenders: {
      name: "性犯罪者",
      description: "公開されている登録性犯罪者リストとの照合。",
    },
    videos: {
      name: "動画",
      description: "公開動画プラットフォームから顔を抽出して照合。",
    },
    police_photos: {
      name: "警察写真",
      description: "公開されている警察記録データベースとの比較。",
    },
    news_and_blogs: {
      name: "ニュース＆ブログ",
      description: "ニュースアーカイブ、編集コンテンツ、ブログを検索。",
    },
  },
  header: {
    scan: "スキャン",
    history: "履歴",
    pricing: "料金",
    account: "アカウント",
    logout: "ログアウト",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright: "© 2024 Digital Forensicist. 全著作権所有。精密本人確認。",
    privacy: "プライバシーポリシー",
    terms: "利用規約",
    docs: "ドキュメント",
    support: "サポート",
  },
  common: {
    loading: "読み込み中...",
    error: "エラー",
    cancel: "キャンセル",
    back: "戻る",
  },
  errors: {
    upload_failed: "アップロードに失敗しました。もう一度お試しください。",
    not_enough_tokens: "この検索を実行するのに十分なトークンがありません。",
  },
  login: {
    disclaimer:
      "このアプリを使用するにはアカウントが必要です。スパムメールは送らず、メールアドレスも共有しません。プライバシー保護のためAppleでのログインをお勧めします。",
  },
  results: {
    input_source: "入力ソース",
    match_thumbnail: "一致画像のサムネイル",
    extraction_id: "抽出ID",
    scan_analysis: "スキャン分析",
    scan_description:
      "生体認証逆引き検索が完了しました。公開レジストリとソーシャルインデックスで%{count}件の潜在的な一致が見つかりました。",
    col_identity_map: "アイデンティティマップ",
    col_verification_path: "検証パス",
    col_bio_match_score: "バイオマッチスコア",
    col_action: "アクション",
    export_pdf: "PDFエクスポート",
    exporting: "生成中...",
    verified: "認証済み",
    details: "詳細",
    details_tooltip: "正確な顔比較を実行",
    details_loading: "比較中...",
    copied: "コピーしました！",
    copy_url: "URLをコピー",
    displaying: "%{total}件中%{count}件の検出を表示",
  },
};

export default ja;
